import { type FC, type ReactNode } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  type DialogProps,
} from '@mui/material';

import { type ConfirmationProps } from '#packages/web/types/confirmation-props';

export type DeleteConfirmationDialogProps = DialogProps &
  ConfirmationProps & {
    dialogTitle?: ReactNode;

    dialogContent?: ReactNode;

    confirmButtonLabel?: ReactNode;
    cancelButtonLabel?: ReactNode;
  };

export const DeleteConfirmationDialog: FC<DeleteConfirmationDialogProps> = ({
  onConfirm,
  onCancel,

  dialogTitle = 'Delete',
  dialogContent,

  cancelButtonLabel = 'Cancel',
  confirmButtonLabel = 'Delete',

  ...props
}) => (
  <Dialog maxWidth="xs" {...props}>
    <DialogTitle>{dialogTitle}</DialogTitle>
    <DialogContent>
      <Stack spacing={2}>
        <Typography typography="body1">
          Are you sure you want to delete this item?
        </Typography>
        <Alert severity="warning">This action cannot be undone.</Alert>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button autoFocus onClick={onCancel}>
        {cancelButtonLabel}
      </Button>
      <Button onClick={onConfirm} color="error">
        {confirmButtonLabel}
      </Button>
    </DialogActions>
  </Dialog>
);
